/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Planner_LinkInputs */

const en_control_planner_link = /** @type {(inputs: Control_Planner_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share URL`)
};

const zh_control_planner_link = /** @type {(inputs: Control_Planner_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享链接`)
};

/**
* | output |
* | --- |
* | "Share URL" |
*
* @param {Control_Planner_LinkInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_planner_link = /** @type {((inputs?: Control_Planner_LinkInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Planner_LinkInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_planner_link(inputs)
	return zh_control_planner_link(inputs)
});
export { control_planner_link as "control.planner.link" }